/******************************************************************************
 * Copyright (c) 2016 - 2021.                                                 *
 * Yega Yazilim ve Bilisim Hizmetleri Dis Tic Ltd Sti (Yega Yazilim)          *
 * All Rights Reserved.                                                       *
 *                                                                            *
 * The software and data contained herein are confidential and proprietary    *
 * information of Yega Yazilim ("Confidential Information").                  *
 *                                                                            *
 * Users of this software may not disclose such Confidential Information and  *
 * shall use it only in accordance with the terms of the license agreement    *
 * they entered into with Yega Yazilim.                                       *
 *                                                                            *
 * Author:  Ahmet Dogramaci                                                   *
 * Date:    2021-09-22                                                        *
 ******************************************************************************/

class QuoteProduct {
    constructor() {
        this.id = null;
        this.attribute_store = {};
        this.detail_attributes_hash_by_cfg_item_id = {}
        this.template_version = null;
        this.quote_product_details = [];
        this.cfg_template_id = null;
    }

    buildFromJson(json){
        Object.assign(this,json);
    }

    set configuration_template_version(version){
        this.template_version= version;
    }

    initDetailAttributesHash(cfg_item_id){
        if(!this.detail_attributes_hash_by_cfg_item_id[cfg_item_id]){
            this.detail_attributes_hash_by_cfg_item_id[cfg_item_id] = {}
        }
    }

    get saved_cfg_item_ids(){
        return this.quote_product_details.map((quote_product_detail)=>{return quote_product_detail.cfg_item_id;})
    }

    get cfg_item_ids(){
        if(this.template_version){
            return this.template_version.selected_nodes.map((node)=>{return node.cfg_item_id;});
        }else{
            return this.quote_product_details.map((detail)=>{return detail.cfg_item_id;});
        }
    }

    get attributes_string(){
        let strings_array=[];
        Object.keys(this.attribute_store).forEach((attribute_name)=>{
            let string = `${attribute_name}~${this.attribute_store[attribute_name] ?? ''}`
            strings_array.push(string);
        });
        return strings_array.join('|');
    }

    get detail_attributes_string(){
        let attribute_texts = [];
        Object.keys(this.detail_attributes_hash_by_cfg_item_id).forEach((cfg_item_id)=>{
            let attribute_hash = this.detail_attributes_hash_by_cfg_item_id[cfg_item_id];
            let attr_strings = [];
            Object.keys(attribute_hash).forEach((attribute_name)=>{
                let attribute_value = attribute_hash[attribute_name];
                let attr_string = `${attribute_name}~${attribute_value ?? ''}`;
                attr_strings.push(attr_string);
            });
            let attribute_text = attr_strings.join('|');
            attribute_texts.push(`${cfg_item_id}=>${attribute_text}`);
        });
        return attribute_texts.join('!;!');
    }

    set cfg_template_version_id(value){
        this.template_version_id = value;
    }

    get cfg_template_version_id(){
        if(this.template_version){
            return this.template_version.current_version_id;
        }else{
            return this.template_version_id;
        }
    }

    update(store){
        return store
            .dispatch('NoSpinnerQuoteProductsStore/update', {
                id: this.id,
                cfg_template_version_id: this.cfg_template_version_id,
                cfg_item_ids: this.cfg_item_ids,
                attributes_string:this.attributes_string,
                detail_attributes_string: this.detail_attributes_string
            })
            .catch((error)=>{alert(error.response ? error.response.data : error);});
    }

    updateAttributeValue(store,attribute_name,attribute_value){
        return store
            .dispatch('NoSpinnerQuoteProductAttributeValuesStore/update', {
                id: this.id,
                attribute_name:attribute_name,
                attribute_value: attribute_value
            })
            .catch((error)=>{alert(error.response ? error.response.data : error);});
    }
}

export default QuoteProduct;
